export const SHOW_EXTENDED_REVIEW_REQUEST = 'SHOW_EXTENDED_REVIEW_REQUEST'
export const SHOW_EXTENDED_REVIEW_TOGGLE = 'SHOW_EXTENDED_REVIEW_TOGGLE'
export const SHOW_EXTENDED_REVIEW_FAIL = 'SHOW_EXTENDED_REVIEW_FAIL'
